import { render, staticRenderFns } from "./Ozon.vue?vue&type=template&id=7ffcef05&scoped=true"
import script from "./Ozon.vue?vue&type=script&lang=js"
export * from "./Ozon.vue?vue&type=script&lang=js"
import style0 from "./Ozon.vue?vue&type=style&index=0&id=7ffcef05&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffcef05",
  null
  
)

export default component.exports